jQuery(document).on("click", ".agegate .btn", function(e){
    e.preventDefault();
    document.cookie = "agegate = true";
    jQuery(this).parents(".agegate-wrapper").hide();
});

//firefox checkbox fix
if(jQuery(".agegate").length > 0){
    if(jQuery(".agegate #tick-checkbox").is(':checked')) {
        jQuery(".agegate .btn").removeClass("disabled");
    } else {
        jQuery(".agegate .btn").addClass("disabled");;
    }
}

jQuery(".agegate #tick-checkbox").change(function() {
    if(this.checked) {
        jQuery(".agegate .btn").removeClass("disabled");
    } else {
        jQuery(".agegate .btn").addClass("disabled");;
    }
});